const completedStageCount = (stageUpdates = []) => {
  return stageUpdates.filter((item) => item.status).length;
};

const StageProgress = ({ stageUpdates, stageId, status }) => {
  return (
    <p className="bg-blue-100 rounded">
      {completedStageCount(stageUpdates)} / 8

      {!status && (
        <span className="text-sky-600 font-figtreeMedium">
          {` (Stage - ${stageId})`}
        </span>
      )}
    </p>
  );
};

export default StageProgress;